import { takeEvery, takeLatest, put, call, select } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import utils from '../utils';
import Api from '../api';
import patternSaga from './patternSaga';
import * as pathname from 'shared/routes/urlLocations';
import { ActionTypes as SharedActionTypes } from 'shared/constants';
import { projectsApi, history } from 'shared/routes/urlLocations';
import notification from "../utils/notifications";
import { isSp } from 'shared/utils/isSp';


const projectsOngoingSagaConfig = {
  requestFunction: Api.Projects.getProjects,
  requestUrl: `${utils.config.apiProjectUrl}/projects/ongoing`,
  onFailure: {
    redirectTo: pathname.homePage,
    notification: true
  }
};

const projectsFeaturedSagaConfig = {
  requestFunction: Api.Projects.toggleFeaturedStatus,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
};

const projectsFinishedSagaConfig = {
  requestFunction: Api.Projects.getProjects,
  requestUrl: `${utils.config.apiProjectUrl}/projects/finished`,
  onFailure: {
    redirectTo: pathname.homePage,
    notification: true
  }
};

const projectsRejectedSagaConfig = {
  requestFunction: Api.Projects.getProjects,
  requestUrl: `${utils.config.apiProjectUrl}/projects/rejected`,
  onFailure: {
    redirectTo: pathname.homePage,
    notification: true
  }
};

const projectsPendingSagaConfig = {
  requestFunction: Api.Projects.getProjects,
  requestUrl: `${utils.config.apiProjectUrl}/projects/pending`,
  onFailure: {
    redirectTo: pathname.homePage,
    notification: true
  }
};

const projectDetailsSagaConfig = {
  spinner: true,
  requestFunction: Api.Projects.getProjectDetails,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
  onFailure: {
    redirectTo: pathname.homePage,
    notification: false
  }
};

const projectApproveSagaConfig = {
  spinner: true,
  requestFunction: Api.Projects.approveProject,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
  onSuccess: {
    redirectTo: [pathname.projects, { activeTab: '3' }],
    notification: {
      staticNotification: true,
      data: {
        code: '4'
      }
    }
  },
  onFailure: {
    notification: true
  }
};

const projectRejectSagaConfig = {
  spinner: true,
  requestFunction: Api.Projects.rejectProject,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
  onSuccess: {
    redirectTo: [pathname.projects, { activeTab: '3' }],
    notification: {
      staticNotification: true,
      data: {
        code: '5'
      }
    }
  },
  onFailure: {
    notification: true
  }
};

const changeProjectPublicVisibility = {
  spinner: true,
  requestFunction: Api.Projects.changeProjectPublicVisibility,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: {
        code: '14'
      }
    }
  },
  onFailure: {
    notification: true
  }
}

const editProjectEndDate = {
  spinner: true,
  requestFunction: Api.Projects.editProjectEndDate,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: {
        code: '13'
      }
    }
  },
  onFailure: {
    notification: true
  }
};

const editProjectHighlights = {
  spinner: true,
  requestFunction: Api.Projects.editProjectHighlights,
  requestUrl: `${utils.config.apiProjectUrl}/projects`,
  onSuccess: {
    notification: {
      staticNotification: true,
      data: {
        code: '15'
      }
    }
  },
  onFailure: {
    notification: true
  }
};


const projectRejectionsHistorySagaConfig = {
  requestFunction: Api.Projects.getProjectRejectionsHistory,
  requestUrl: `${utils.config.apiProjectUrl}/projects`
};


const getFileCategoriesConfig = {
  requestFunction: Api.Projects.fileCategories,
  requestUrl: `${utils.config.apiFileCategoriesUrl}`,
  onFailure: {
    notification: true
  }
};


function* closeProject({ id, data }) {
  yield put({ type: ActionTypes.SHOW_SPINNER });

  try {
    yield put({ type: ActionTypes.PROJECT_CLOSE_STARTED });

    const result = yield call(Api.Projects.closeProject, projectsApi + "/" + id + "/close", {
      fundingStatus: data.status,
      fundedAmount: data.amount
    });

    if (result && result.request && result.request.status === 204) {
      yield put({ type: ActionTypes.PROJECT_CLOSE_SUCCESS });

      yield put({
        type: ActionTypes.ONGOING_PROJECTS_GET_REQUEST,
        requestConfig: {
          projection: 'approved',
          sort: 'publishedDate,desc',
          size: 10,
          page: 0
        }
      });

      yield put({
        type: ActionTypes.FINISHED_PROJECTS_GET_REQUEST,
        requestConfig: {
          projection: 'approved',
          sort: 'publishedDate,desc',
          size: 10,
          page: 0
        }
      });

      const isSpCheck = yield call(isSp);
      const notificationClass = isSpCheck
        ? 'ant-notification-sp'
        : 'ant-notification-success ant-notification-notice-description';

      yield call(notification, {
        type: 'success',
        data: { description: 'Your project was successfully closed.' },
        className: notificationClass
      });

    } else if (result && result.status === 401) {
      const isSpCheck = yield call(isSp);
      const notificationClass = isSpCheck
        ? ''
        : 'ant-notification-success ant-notification-notice-description';

      yield sessionStorage.clear();
      yield history.push('/');

      yield put({
        type: ActionTypes.PROJECT_CLOSE_FAILURE,
        message: 'Please, authorize again!',
        notification: true
      });

      yield call(notification, {
        type: 'error',
        className: notificationClass,
        data: { description: 'Please, authorize again!' }
      });

    } else {
      var errorCode = 'UNKNOWN';

      if (result && result.response && result.response.error && result.response.error.code) {
        errorCode = result.response.error.code;
      }

      const errorMessage = "You cannot close strategic partner projects.";

      yield put({
        type: ActionTypes.PROJECT_CLOSE_FAILURE,
        message: result.response,
        notification: true
      });

      yield call(notification, {
        type: 'error',
        data: { description: errorMessage }
      });
    }

  } catch (e) {
    var errorMessage = 'Unknown error occurred.';
    if (e && e.message) {
      errorMessage = e.message;
    }

    yield put({
      type: ActionTypes.PROJECT_CLOSE_FAILURE,
      message: errorMessage,
      notification: true
    });

    yield call(notification, {
      type: 'error',
      data: { description: errorMessage }
    });
  } finally {
    yield put({ type: ActionTypes.PROJECT_CLOSE_FINISHED });
    yield put({ type: ActionTypes.HIDE_SPINNER });
  }
}






export default function* watchProjectsSaga() {
  yield takeEvery(ActionTypes.ONGOING_PROJECTS_GET_REQUEST, patternSaga, projectsOngoingSagaConfig);
  yield takeEvery(ActionTypes.FINISHED_PROJECTS_GET_REQUEST, patternSaga, projectsFinishedSagaConfig);
  yield takeEvery(ActionTypes.PENDING_PROJECTS_GET_REQUEST, patternSaga, projectsPendingSagaConfig);
  yield takeEvery(ActionTypes.REJECTED_PROJECTS_GET_REQUEST, patternSaga, projectsRejectedSagaConfig);
  yield takeEvery(ActionTypes.PROJECT_DETAILS_GET_REQUEST, patternSaga, projectDetailsSagaConfig);
  yield takeEvery(ActionTypes.PROJECT_APPROVE_REQUEST, patternSaga, projectApproveSagaConfig);
  yield takeEvery(ActionTypes.PROJECT_REJECT_REQUEST, patternSaga, projectRejectSagaConfig);
  yield takeEvery(ActionTypes.CHANGE_PROJECT_PUBLIC_VISIBILITY_REQUEST, patternSaga, changeProjectPublicVisibility)
  yield takeEvery(ActionTypes.PROJECT_EDIT_END_DATE_REQUEST, patternSaga, editProjectEndDate);
  yield takeEvery(ActionTypes.PROJECT_EDIT_HIGHLIGHTS_REQUEST, patternSaga, editProjectHighlights);
  yield takeEvery(
    ActionTypes.PROJECT_REJECTIONS_HISTORY_GET_REQUEST,
    patternSaga,
    projectRejectionsHistorySagaConfig
  );
  yield takeLatest(SharedActionTypes.GET_FILE_CATEGORIES, patternSaga, getFileCategoriesConfig);
  yield takeEvery(ActionTypes.PROJECT_FEATURED_TOGGLE, patternSaga, projectsFeaturedSagaConfig);
  yield takeLatest(ActionTypes.PROJECT_CLOSE_REQUEST, closeProject);
}
